import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Ads = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5022 3.30525C14.2852 2.77714 12.9424 2.48438 11.5312 2.48438C6.01703 2.48438 1.54688 6.95453 1.54688 12.4688C1.54688 17.983 6.01703 22.4531 11.5312 22.4531C17.0455 22.4531 21.5156 17.983 21.5156 12.4688C21.5156 11.042 21.2164 9.68512 20.6772 8.4575L18.8052 10.3141C19.0072 10.9971 19.1156 11.7203 19.1156 12.4688C19.1156 16.6575 15.72 20.0531 11.5312 20.0531C7.34252 20.0531 3.94688 16.6575 3.94688 12.4688C3.94688 8.28002 7.34252 4.88438 11.5312 4.88438C12.2547 4.88438 12.9545 4.98566 13.6172 5.17483L15.5022 3.30525ZM17.78 3.58125L17.96 4.82912L17.96 4.82916L18.1088 5.86113L20.4103 6.18682L19.7679 6.82393L19.768 6.82405L18.0267 8.55102L18.0266 8.55086L17.0511 9.51832L15.0784 8.86692L14.4208 6.91275L17.78 3.58125ZM15.9809 12.5437C15.9809 15.0012 13.9887 16.9934 11.5312 16.9934C9.0738 16.9934 7.08164 15.0012 7.08164 12.5437C7.08164 10.0863 9.0738 8.09414 11.5312 8.09414C12.4699 8.09414 13.3408 8.38481 14.0586 8.88106L10.9072 12.0325C10.6143 12.3254 10.6143 12.8002 10.9072 13.0931C11.2001 13.386 11.6749 13.386 11.9678 13.0931L15.1319 9.92901C15.6659 10.663 15.9809 11.5666 15.9809 12.5437Z"
        fill="url(#paint0_linear_5572_57328)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5572_57328"
          x1="11.5312"
          y1="10.8735"
          x2="11.5312"
          y2="22.4531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B64BF8" />
          <stop offset="1" stopColor="#7B00C7" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default Ads
